<template>
  <div class="row">
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-row>
              <b-col cols="12" md="4" >
                <b-form-group>
                  <v-select
                    v-model="filter.trainingSystemId"
                    :options="trainingSystems"
                    :reduce="option => option.value"
                    :clearable = false
                    placeholder="Hệ đào tạo"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4">
                <b-form-group>
                  <v-select
                    v-model="filter.courseId"
                    :options="courses"
                    :reduce="option => option.value"
                    placeholder="Khóa"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4">
                <b-form-group>
                  <v-select
                    v-model="filter.courseSemesterId"
                    :options="courseSemesters"
                    :reduce="option => option.value"
                    placeholder="Học kỳ"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group>
                  <v-select
                    v-model="filter.departmentId"
                    :options="departments"
                    :reduce="option => option.value"
                    placeholder="Khoa/Bộ môn"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group>
                  <v-select
                    v-model="filter.majorId"
                    :options="majors"
                    :reduce="option => option.value"
                    placeholder="Chuyên ngành"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="3">
                <b-form-group>
                  <v-select
                    v-model="filter.classId"
                    :options="classes"
                    :reduce="option => option.value"
                    placeholder="Lớp cố định"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="2">
                <b-form-input
                  v-model="filter.student"
                  placeholder="Tên/Mã SV"
                />
              </b-col>
              <b-col cols="12" md="3">
                <b-form-group>
                  <v-select
                    v-model="filter.policyId"
                    :options="allowances"
                    :reduce="option => option.id"
                    :menu-props="{ top: true, offsetY: true }"
                    label="name"
                    class="truncate-select"
                    placeholder="Chế độ chính sách"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <div class="text-right">
                  <b-button
                    v-if="creatable"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    @click="onSearch"
                    class="mr-1"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="FilterIcon" /> Lọc
                    </span>
                  </b-button>
                  <b-button
                    v-if="creatable"
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    v-b-modal.studentPoliciesSaveModal
                    variant="success"
                    @click="onCreateData"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="PlusIcon" /> Thêm mới
                    </span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="12">
                <div class="d-flex align-items-center mb-1 mt-0">
                  <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                    đến {{ (filter.itemsPerPage * (filter.currentPage) >= totalRows)? totalRows : filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                  </span>
                </div>
                <vue-good-table
                  mode="remote"
                  :columns="columns"
                  :rows="dataSources"
                  :pagination-options="paginationOptions"
                  :total-rows="totalRows"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                >
                  <div
                    slot="emptystate"
                    style="text-align: center; font-weight: bold"
                  >
                    Không có bản ghi nào !
                  </div>
                  <template
                    slot="table-row"
                    slot-scope="props"
                  >
                    <span v-if="props.column.field === 'stt'">
                      {{ props.row.originalIndex + 1 }}
                    </span>
                    <span v-else-if="props.column.field === 'action'">
                      <b-button
                        v-if="updatable"
                        v-b-modal.studentPoliciesSaveModal
                        variant="primary"
                        class="btn-icon"
                        size="sm"
                        @click="onEditData(props.row)"
                      >
                        <feather-icon icon="Edit2Icon" />
                      </b-button>
                      <b-button
                        v-if="deletable"
                        variant="danger"
                        class="btn-icon"
                        style="margin-left: 6px"
                        size="sm"
                        @click="onDeleteData(props.row)"
                      >
                        <feather-icon icon="TrashIcon" />
                      </b-button>
                    </span>

                    <!-- Column: Common -->
                    <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                  </template>

                  <!-- pagination -->
                  <template
                    slot="pagination-bottom"
                    slot-scope="props"
                  >
                    <div class="d-flex justify-content-between flex-wrap">
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị {{ filter.itemsPerPage * (filter.currentPage-1) +1 }}
                          đến {{ (filter.itemsPerPage * (filter.currentPage) >= totalRows)? totalRows : filter.itemsPerPage * (filter.currentPage) }} &nbsp; của {{ totalRows }} bản ghi
                        </span>
                      </div>
                      <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> Hiển thị </span>
                        <b-form-select
                          v-model="filter.itemsPerPage"
                          :options="itemsPerPageOptions"
                          class="mx-1"
                          @input="(value) => props.perPageChanged({ currentPerPage: value })"
                        />
                        <span class="text-nowrap"> bản ghi/trang</span>
                      </div>
                      <div>
                        <b-pagination
                          :value="1"
                          :total-rows="totalRows"
                          :per-page="filter.itemsPerPage"
                          class="mt-1 mb-0"
                          @input="(value) => props.pageChanged({ currentPage: value })"
                        />
                      </div>
                    </div>
                  </template>
                </vue-good-table>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
    <studentPoliciesSave
      ref="studentPoliciesSaveFormRef"
      :data-source="currentDataSource"
      @succeed="onSucceed"
    />
  </div>
</template>

<script>
import {
  BButton, BCard, BCol, BContainer, BFormGroup, BFormInput, BFormSelect, BOverlay, BPagination, BRow,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { PermissionCode, ResourceCode } from '@/const/code'
import vSelect from 'vue-select'
import { getUser } from '@/auth/utils'
import StudentPoliciesSave from '@/views/student-policies/StudentPoliciesSave.vue'
import { showErrorToast, showSuccessToast } from '@/utils/notification'

export default {
  name: 'StudentPolicies',
  directives: {
    Ripple,
  },
  components: {
    BFormGroup,
    vSelect,
    BFormInput,
    StudentPoliciesSave,
    BButton,
    BCard,
    BCol,
    BContainer,
    BFormSelect,
    BOverlay,
    BPagination,
    BRow,
    VueGoodTable,
  },
  data() {
    return {
      isLoading: false,
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        organizationId: getUser().orgId,
        trainingSystemId: null,
        departmentId: null,
        courseId: null,
        courseSemesterId: null,
        majorId: null,
        classId: null,
        policyId: null,
        student: null,
        code: null,
        status: 1,
        sort: null,
      },
      currentDataSource: undefined,
      paginationOptions: {
        enabled: true,
      },
      itemsPerPageOptions: [10, 20, 30, 50, 80, 100],
      columns: [
        {
          label: 'STT',
          field: 'stt',
          width: '80px',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Tên sinh viên',
          field: 'student',
          filterOptions: {
            enabled: false,
            trigger: 'enter',
          },
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Lớp cố định',
          field: 'className',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Khóa học',
          field: 'courseName',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Học kỳ',
          field: 'courseSemesterName',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: 'Chế độ',
          field: 'policy',
          sortable: false,
          thClass: 'text-center',
        },
        {
          label: '',
          field: 'action',
          width: '120px',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      dataSources: 'studentPolicies/studentPolicies',
      totalRows: 'studentPolicies/totalRows',
      trainingSystems: 'dropdown/trainingSystems',
      courses: 'dropdown/courses',
      courseSemesters: 'dropdown/courseSemesters',
      departments: 'dropdown/departments',
      majors: 'dropdown/majors',
      classes: 'dropdown/classes',
      allowances: 'policies/policies',
    }),
    creatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.STUDENTALLOWANCE)
    },
    updatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.STUDENTALLOWANCE)
    },
    deletable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.STUDENTALLOWANCE)
    },
  },

  watch: {
    // listening change data init
    'filter.trainingSystemId': function (newVal) {
      this.onTrainingSystemsChange(newVal)
    },
    'filter.courseId': function (newVal) {
      this.onCoursesChange(newVal)
    },
    'filter.departmentId': function (newVal) {
      this.onDepartmentChange(newVal)
    },
    'filter.majorId': function (newVal) {
      this.onMajorChange(newVal)
    },
  },
  async created() {
    this.isLoading = true
    try {
      await this.getTrainingSystems({ organizationId: getUser().orgId })

      if (this.trainingSystems.length > 0) {
        this.filter.trainingSystemId = this.trainingSystems[0].value
      }
      await Promise.all([
        this.getDepartments({ organizationId: getUser().orgId }),
        this.getCourses({ trainingSystemId: this.filter.trainingSystemId, organizationId: getUser().orgId }),
        this.getAllowances({
          currentPage: 1,
          itemsPerPage: 100,
        }),
      ])
    } catch (e) {
      showErrorToast(this, e)
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    ...mapMutations({
      setCourses: 'dropdown/SET_COURSES',
      setCourseSemester: 'dropdown/SET_COURSE_SEMESTERS',
      setMajors: 'dropdown/SET_MAJORS',
      setClasses: 'dropdown/SET_CLASSES',
    }),
    ...mapActions({
      getDataSources: 'studentPolicies/getStudentPolicies',
      deleteDataSource: 'studentPolicies/deleteStudentPolicies',
      getTrainingSystems: 'dropdown/getTrainingSystems',
      getCourses: 'dropdown/getCourses',
      getCourseSemesters: 'dropdown/getCourseSemesters',
      getDepartments: 'dropdown/getDepartments',
      getMajors: 'dropdown/getMajors',
      getClasses: 'dropdown/getClasses',
      getAllowances: 'policies/getPolicies',
    }),
    async onTrainingSystemsChange(event) {
      this.setCourses([])
      this.filter.courseId = null

      await this.getCourses({
        organizationId: getUser().orgId,
        trainingSystemId: event,
      })
    },
    async onCoursesChange(event) {
      this.setMajors([])
      this.filter.courseSemesterId = null

      await this.getCourseSemesters({
        organizationId: getUser().orgId,
        courseId: event,
      })
      this.filter.classId = null
    },
    async onDepartmentChange(event) {
      this.setMajors([])
      this.filter.majorId = null

      await this.getMajors({
        organizationId: getUser().orgId,
        departmentId: event,
      })
      this.filter.classId = null
    },
    async onMajorChange(event) {
      this.setClasses([])
      await this.getClasses({
        organizationId: getUser().orgId,
        courseId: this.filter.courseId,
        trainingSystemId: this.filter.trainingSystemId,
        departmentId: this.filter.departmentId,
        majorId: event,
      })
      this.filter.classId = null
    },
    onCreateData() {
      this.currentDataSource = undefined
    },
    onEditData(studentDiscipline) {
      const {
        rowNum,
        originalIndex,
        vgt_id,
        ...rest
      } = studentDiscipline
      this.currentDataSource = rest
    },
    onDeleteData(studentDiscipline) {
      this.$swal({
        title: `Bạn chắc chắn muốn xóa sinh viên hưởng chế độ chính sách <span class="text-danger">${studentDiscipline.student}</span>?`,
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.isLoading = true
          try {
            const response = await this.deleteDataSource(studentDiscipline.id)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                showSuccessToast(this, message)
                await this.getDataSources(this.filter)
              } else {
                showErrorToast(this, message)
              }
            }
          } catch (e) {
            showErrorToast(this, e)
          } finally {
            this.isLoading = false
          }
        }
      })
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getDataFromStore()
    },
    async getDataFromStore() {
      this.isLoading = true
      try {
        await this.getDataSources(this.filter)
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async onPerPageChange(param) {
      this.updateParams({ currentPage: 1, itemsPerPage: param.currentPerPage })
      await this.getDataFromStore()
    },
    async onSortChange(param) {
      if (param.length > 0) {
        const { field, type } = param[0]
        if (field === 'name') this.updateParams({ sort: `1_${type}` })
        else if (field === 'code') this.updateParams({ sort: `2_${type}` })
        else this.updateParams({ sort: `3_${type}` })
      }
      await this.getDataFromStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'name')) this.updateParams({ name: columnFilters.name })
      if (Object.hasOwn(columnFilters, 'code')) this.updateParams({ code: columnFilters.code })
      if (Object.hasOwn(columnFilters, 'status')) this.updateParams({ status: columnFilters.status })
      await this.getDataFromStore()
    },
    async onSucceed() {
      await this.getDataFromStore()
    },
    async onSearch() {
      await this.getDataFromStore()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
